import React, { useEffect, useState } from "react";
import {
  X,
  Save,
  Trash2,
  Clock,
  FileText,
  Building2,
  MapPin,
} from "lucide-react";
import "./app.css";
import Loading from "./loading.js";
import { secretKey } from "./data";

const API = "https://apiftpsplit.ftpeople.pl";
const hdrs = { "Content-Type": "application/json", Authorization: secretKey };

const REGIONS = [
  "Dolnośląskie",
  "Kujawsko-Pomorskie",
  "Lubelskie",
  "Lubuskie",
  "Łódzkie",
  "Małopolskie",
  "Mazowieckie",
  "Opolskie",
  "Podkarpackie",
  "Podlaskie",
  "Pomorskie",
  "Śląskie",
  "Świętokrzyskie",
  "Warmińsko-Mazurskie",
  "Wielkopolskie",
  "Zachodniopomorskie",
];

const BANKS = [
  "mBank S.A.",
  "Bank Millennium S.A.",
  "Bank BPH S.A.",
  "BNP Paribas Bank Polska S.A.",
  "Deutsche Bank Polska S.A.",
  "Raiffeisen Bank International AG",
  "Getin Noble Bank S.A.",
  "ING Bank Śląski S.A.",
  "Santander Bank Polska S.A.",
  "Santander Consumer Bank S.A.",
  "PKO BP S.A.",
  "PEKAO S.A.",
  "Bank Ochrony Środowiska S.A.",
  "Credit Agricole Bank Polska S.A.",
  "Alior Bank S.A.",
  "VeloBank S.A.",
  "Nest Bank S.A.",
  "Plus Bank S.A.",
  "Bank Pocztowy S.A.",
  "Bank Handlowy w Warszawie S.A.",
  "DNB Bank Polska S.A.",
  "Cofidis Oddział w Polsce",
  "Bank Gospodarstwa Krajowego",
  "PTF Bank S.A.",
  "Ikano Bank AB Oddział w Polsce",
  "KRUK S.A.",
  "Prokura NSFIZ",
  "Profi Credit S.A.",
  "Ultimo NSFIZ",
  "Presco",
  "BEST I NSFIZ",
  "BEST II NSFIZ",
  "BEST III NSFIZ",
  "Provident Polska S.A.",
  "SVEA Ekonomi",
  "Open Finance",
  "Intrum Sp. z o.o.",
  "Vivus Finance",
  "Zaplo Sp. z o.o.",
  "Aasa Polska S.A.",
  "Smartney Grupa Oney S.A.",
];

const HOURS = [...Array(25)].map((_, i) => i);

const parseValidation = (lead) => {
  try {
    const v = JSON.parse(lead.validation);
    return {
      bank: v.bank || "",
      ammount: v.ammount || "",
      creditDate: v.creditDate || "",
      company: v.company || "NIE",
      change: v.change || "NIE",
      region: v.region || "",
    };
  } catch {
    return {
      bank: "",
      ammount: "",
      creditDate: "",
      company: "NIE",
      change: "NIE",
      region: "",
    };
  }
};

const AdditionalLead = (props) => {
  const lead = props.lead;
  const isSluzebnosc = lead?.company === "SLUZEBNOSC";
  const isCHF = lead?.company === "CHF";

  const [loading, setLoading] = useState(true);
  const [hoursFrom, setHoursFrom] = useState(0);
  const [hoursTo, setHoursTo] = useState(24);
  const [note, setNote] = useState("");

  /* validation fields */
  const [bank, setBank] = useState("");
  const [ammount, setAmmount] = useState("");
  const [cDate, setCDate] = useState("");
  const [cCompany, setCCompany] = useState("NIE");
  const [cChange, setCChange] = useState("NIE");
  const [region, setRegion] = useState("");

  useEffect(() => {
    if (lead?.hours) {
      const [f, t] = lead.hours.split("-");
      setHoursFrom(Number(f) || 0);
      setHoursTo(Number(t) || 24);
    }
    setNote(lead?.clientNote || "");
    const v = parseValidation(lead);
    setBank(v.bank);
    setAmmount(v.ammount);
    setCDate(v.creditDate);
    setCCompany(v.company);
    setCChange(v.change);
    setRegion(v.region);
    setLoading(false);
  }, []);

  const buildBody = (clearValidation = false) => ({
    id: lead.id,
    field: "additional",
    userId: props.user.id,
    userName: props.user.name,
    value: {
      hours: `${hoursFrom}-${hoursTo}`,
      note,
      validation: clearValidation
        ? {
            bank: "",
            ammount: "",
            creditDate: "",
            company: "NIE",
            change: "NIE",
            region: "",
          }
        : {
            bank,
            ammount,
            creditDate: cDate,
            company: cCompany,
            change: cChange,
            region,
          },
    },
  });

  const save = async (clearValidation = false) => {
    await fetch(`${API}/editLead`, {
      method: "POST",
      headers: hdrs,
      body: JSON.stringify(buildBody(clearValidation)),
    }).catch(() => {});
    props.close();
  };

  const toHours = HOURS.filter((h) => h > hoursFrom);

  if (loading) return <Loading />;

  return (
    <div
      className="sn-overlay"
      onClick={(e) => {
        if (e.target === e.currentTarget) props.close();
      }}
    >
      <div className="sn-modal sn-modal--wide">
        {/* Header */}
        <div className="sn-header">
          <div>
            <h2 className="sn-title">Dodatkowe informacje</h2>
            <div className="al-header-meta">
              <span>{lead?.name}</span>
              <span>{lead?.phone}</span>
              <span>{lead?.mail}</span>
            </div>
          </div>
          <button className="ld-close" onClick={props.close}>
            <X size={18} />
          </button>
        </div>

        {/* Body */}
        <div className="sn-body">
          {/* ── Contact hours ── */}
          <div className="al-section">
            <div className="al-section-title">
              <Clock size={15} /> Godziny kontaktu
            </div>
            <div className="al-hours">
              <div className="al-hour-pick">
                <span className="db-field-label">Od</span>
                <select
                  className="db-input db-select"
                  value={hoursFrom}
                  onChange={(e) => {
                    const v = Number(e.target.value);
                    setHoursFrom(v);
                    if (v >= hoursTo) setHoursTo(v + 1);
                  }}
                >
                  {HOURS.map((h) => (
                    <option key={h} value={h}>
                      {h}:00
                    </option>
                  ))}
                </select>
              </div>
              <span className="al-hours-sep">—</span>
              <div className="al-hour-pick">
                <span className="db-field-label">Do</span>
                <select
                  className="db-input db-select"
                  value={hoursTo}
                  onChange={(e) => setHoursTo(Number(e.target.value))}
                >
                  {toHours.map((h) => (
                    <option key={h} value={h}>
                      {h}:00
                    </option>
                  ))}
                </select>
              </div>
            </div>
          </div>

          {/* ── Client note ── */}
          <div className="al-section">
            <div className="al-section-title">
              <FileText size={15} /> Notatka dla klienta
            </div>
            <textarea
              className="db-input ac-textarea"
              value={note}
              onChange={(e) => setNote(e.target.value)}
              placeholder="Wpisz notatkę dla klienta..."
            />
          </div>

          {/* ── Validation (not for SLUZEBNOSC) ── */}
          {!isSluzebnosc && (
            <div className="al-section">
              <div className="al-section-header">
                <div className="al-section-title">
                  <Building2 size={15} /> Walidacja kontaktu
                </div>
                <button
                  className="lq-btn lq-btn--danger"
                  onClick={() => save(true)}
                >
                  <Trash2 size={13} /> Wyczyść walidację
                </button>
              </div>

              <div className="scc-form-grid">
                {/* Bank */}
                <div className="rp-field" style={{ gridColumn: "1 / -1" }}>
                  <label className="db-field-label">Bank</label>
                  <select
                    className="db-input db-select"
                    value={bank}
                    onChange={(e) => setBank(e.target.value)}
                  >
                    {!bank && <option value="">Wybierz...</option>}
                    {BANKS.map((b) => (
                      <option key={b} value={b}>
                        {b}
                      </option>
                    ))}
                    <option value="Inny">Inny</option>
                  </select>
                  {bank?.includes("Inny") && (
                    <input
                      type="text"
                      className="db-input"
                      placeholder="Wpisz nazwę banku..."
                      value={bank.replace("Inny", "").replace(" - ", "").trim()}
                      onChange={(e) => setBank(e.target.value + " - Inny")}
                      style={{ marginTop: 6 }}
                    />
                  )}
                </div>

                {/* Amount */}
                <div className="rp-field">
                  <label className="db-field-label">Kwota kredytu (PLN)</label>
                  <input
                    type="number"
                    className="db-input"
                    value={ammount}
                    onChange={(e) => setAmmount(e.target.value)}
                  />
                </div>

                {/* Credit date */}
                <div className="rp-field">
                  <label className="db-field-label">Data wypłaty kredytu</label>
                  <input
                    type="date"
                    className="db-input"
                    value={cDate}
                    onChange={(e) => setCDate(e.target.value)}
                  />
                </div>

                {/* Company checkbox */}
                <div className="rp-field">
                  <label className="db-field-label">Kredyt na firmę?</label>
                  <label className="al-checkbox-label">
                    <input
                      type="checkbox"
                      className="db-check"
                      style={{ marginTop: 0 }}
                      checked={cCompany === "TAK"}
                      onChange={(e) =>
                        setCCompany(e.target.checked ? "TAK" : "NIE")
                      }
                    />
                    <span>{cCompany === "TAK" ? "Tak" : "Nie"}</span>
                  </label>
                </div>

                {/* CHF: currency change */}
                {isCHF && (
                  <div className="rp-field">
                    <label className="db-field-label">
                      Przewalutowany w trakcie spłaty?
                    </label>
                    <label className="al-checkbox-label">
                      <input
                        type="checkbox"
                        className="db-check"
                        style={{ marginTop: 0 }}
                        checked={cChange === "TAK"}
                        onChange={(e) =>
                          setCChange(e.target.checked ? "TAK" : "NIE")
                        }
                      />
                      <span>{cChange === "TAK" ? "Tak" : "Nie"}</span>
                    </label>
                  </div>
                )}

                {/* Region */}
                <div className="rp-field">
                  <label className="db-field-label">Region</label>
                  <select
                    className="db-input db-select"
                    value={region}
                    onChange={(e) => setRegion(e.target.value)}
                  >
                    {!region && <option value="">Wybierz...</option>}
                    {REGIONS.map((r) => (
                      <option key={r} value={r}>
                        {r}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
            </div>
          )}

          {/* ── Footer ── */}
          <div className="scc-form-footer">
            <button className="lq-btn lq-btn--muted" onClick={props.close}>
              Anuluj
            </button>
            <button
              className="lq-btn lq-btn--success"
              onClick={() => save(false)}
            >
              <Save size={14} /> Zapisz
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdditionalLead;
